/** @module SiteAdmin/CentricDrive/DownloadFileVersion.js */
define([
	"dojo/_base/declare",
	"csi",
	"csi/action/Controller",
	"csi/comm/GetRequest",
], function(declare,csi,Controller,GetRequest) {

	return declare(Controller, {

		toWriter: function() {

			const fileId = this.getNode().FileId;
			const version = this.getNode().Version;
			const file = this.getParent().$Name;
			var request = new GetRequest("SiteAdmin", "DownloadSpecificFileVersion")
			.addParameter("FileId",fileId )
			.addParameter("Version",version)
			.addParameter("FileVersionName",file )
			.addParameter("CDVersion",this.getNode().CDVersion);

			csi.browserWindow(request.toRequest(), "DownloadFileVersion");
		}
	});
});
